/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cookie_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cookie_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13.823 10.008h.346M18.836 13h.346m-12.35 4.005h.346m13.62-7.948a3.665 3.665 0 0 1-3.668-3.69 3.636 3.636 0 0 1-3.945.314A3.668 3.668 0 0 1 11.554 1 10.997 10.997 0 0 0 1.443 8.904a11.009 11.009 0 0 0 4.255 12.11 10.997 10.997 0 0 0 16.769-5.633c.708-2.192.71-4.55.009-6.743a3.628 3.628 0 0 1-1.677.42ZM10 10.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm6 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.752-7.492c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257ZM19.261 13c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257ZM7.257 17.005c0 .184-.16.244-.248.244-.092 0-.252-.06-.252-.244 0-.197.16-.256.252-.256.088 0 .248.06.248.256Z"
      />
    </g>
    <defs>
      <clipPath id="cookie_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cookie_medium
